export default __webpack_public_path__ + "static/gallery_xl-3daf6445c8954b050c50c3b15e2ff7e0.jpg";